export default __webpack_public_path__ + "static/media/bg.43a95721.png";